module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/grad-program-logo-937c10d38e547d03d6b3768e01c569cd.svg";